// // pages/NotFound.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';

// const NotFound = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 relative overflow-hidden">
//       {/* Animated background elements */}
//       <div className="absolute inset-0 overflow-hidden">
//         <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
//         <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-yellow-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
//         <div className="absolute top-40 left-40 w-80 h-80 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
//       </div>

//       {/* Main content */}
//       <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4">
//         <motion.div
//           initial={{ opacity: 0, y: -50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           className="text-center"
//         >
//           {/* 404 Text */}
//           <motion.h1
//             initial={{ scale: 0 }}
//             animate={{ scale: 1 }}
//             transition={{ 
//               type: "spring",
//               stiffness: 260,
//               damping: 20,
//               delay: 0.2 
//             }}
//             className="text-9xl md:text-[200px] font-bold text-white opacity-90"
//           >
//             <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-600">
//               404
//             </span>
//           </motion.h1>

//           {/* Glitch effect text */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.4 }}
//             className="relative"
//           >
//             <h2 className="text-3xl md:text-5xl font-bold text-white mt-4 glitch" data-text="Page Not Found">
//               Page Not Found
//             </h2>
//           </motion.div>

//           {/* Description */}
//           <motion.p
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.6 }}
//             className="text-gray-300 text-lg md:text-xl mt-6 max-w-md mx-auto"
//           >
//             Oops! The page you're looking for seems to have vanished into the digital void.
//           </motion.p>

//           {/* Animated astronaut or icon */}
//           <motion.div
//             animate={{ 
//               y: [0, -20, 0],
//             }}
//             transition={{
//               duration: 3,
//               repeat: Infinity,
//               repeatType: "reverse"
//             }}
//             className="my-8"
//           >
//             <svg
//               className="w-32 h-32 md:w-48 md:h-48 mx-auto"
//               viewBox="0 0 200 200"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <motion.circle
//                 cx="100"
//                 cy="100"
//                 r="80"
//                 stroke="url(#gradient)"
//                 strokeWidth="3"
//                 initial={{ pathLength: 0 }}
//                 animate={{ pathLength: 1 }}
//                 transition={{ duration: 2, delay: 0.5 }}
//               />
//               <motion.path
//                 d="M100 40 L100 160 M40 100 L160 100"
//                 stroke="url(#gradient)"
//                 strokeWidth="3"
//                 strokeLinecap="round"
//                 initial={{ pathLength: 0 }}
//                 animate={{ pathLength: 1 }}
//                 transition={{ duration: 1.5, delay: 1 }}
//               />
//               <defs>
//                 <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
//                   <stop offset="0%" stopColor="#3B82F6" />
//                   <stop offset="100%" stopColor="#8B5CF6" />
//                 </linearGradient>
//               </defs>
//             </svg>
//           </motion.div>

//           {/* Buttons */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.8 }}
//             className="flex flex-col sm:flex-row gap-4 mt-8"
//           >
//             {/* Back Button */}
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => navigate(-1)}
//               className="group relative px-8 py-4 bg-white/10 backdrop-blur-lg rounded-xl border border-white/20 text-white font-semibold overflow-hidden transition-all duration-300 hover:bg-white/20"
//             >
//               <span className="relative z-10 flex items-center gap-2">
//                 <svg 
//                   className="w-5 h-5 transition-transform group-hover:-translate-x-1" 
//                   fill="none" 
//                   stroke="currentColor" 
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
//                 </svg>
//                 Go Back
//               </span>
//               <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//             </motion.button>

//             {/* Login Button */}
//             <motion.button
//               whileHover={{ scale: 1.05 }}
//               whileTap={{ scale: 0.95 }}
//               onClick={() => navigate('/login')}
//               className="group relative px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl text-white font-semibold overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-purple-500/25"
//             >
//               <span className="relative z-10 flex items-center gap-2">
//                 Login
//                 <svg 
//                   className="w-5 h-5 transition-transform group-hover:translate-x-1" 
//                   fill="none" 
//                   stroke="currentColor" 
//                   viewBox="0 0 24 24"
//                 >
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
//                 </svg>
//               </span>
//               <motion.div
//                 className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600"
//                 initial={{ x: "100%" }}
//                 whileHover={{ x: 0 }}
//                 transition={{ duration: 0.3 }}
//               />
//             </motion.button>
//           </motion.div>
//         </motion.div>

//         {/* Floating particles */}
//         {[...Array(5)].map((_, i) => (
//           <motion.div
//             key={i}
//             className="absolute w-2 h-2 bg-white/30 rounded-full"
//             initial={{ 
//               x: Math.random() * window.innerWidth,
//               y: window.innerHeight + 100
//             }}
//             animate={{ 
//               y: -100,
//               x: Math.random() * window.innerWidth
//             }}
//             transition={{
//               duration: Math.random() * 20 + 10,
//               repeat: Infinity,
//               delay: Math.random() * 5
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default NotFound;



// pages/NotFoundMinimal.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFoundMinimal = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-lg w-full text-center"
      >
        {/* Icon */}
        <motion.div
          initial={{ rotate: -180, opacity: 0 }}
          animate={{ rotate: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mx-auto mb-8"
        >
          <div className="w-32 h-32 mx-auto bg-gradient-to-br from-violet-500 to-purple-600 rounded-full flex items-center justify-center shadow-2xl">
            <span className="text-6xl text-white">?</span>
          </div>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <h1 className="text-6xl font-bold text-gray-900 dark:text-white mb-4">
            404
          </h1>
          <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-8">
            Sorry, we couldn't find the page you're looking for.
          </p>
        </motion.div>

        {/* Buttons */}
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-3 border-2 border-gray-300 dark:border-gray-600 rounded-lg font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
          >
            ← Go Back
          </button>
          <button
            onClick={() => navigate('/login')}
            className="px-6 py-3 bg-gradient-to-r from-violet-500 to-purple-600 text-white rounded-lg font-medium hover:from-violet-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
          >
            Go to Login →
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFoundMinimal;
